import { useEffect, useState } from "react";
import { useSession } from "../store/session";
import { hasUnsentChatInput } from "../lib/chatLinks";

/** Auth mounts the shell in place, so the original URL survives sign-in. */
export default function ChatLinkNavigation() {
  const error = useSession((s) => s.chatLinkError);
  const activeId = useSession((s) => s.activeCompanyId);
  const [retrying, setRetrying] = useState(false);
  useEffect(() => {
    const onHistory = () => {
      if (useSession.getState().chatNavigationReady) void useSession.getState().resolveChatLink();
    };
    const onLeave = (event: BeforeUnloadEvent) => {
      if (!hasUnsentChatInput(useSession.getState())) return;
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("popstate", onHistory);
    window.addEventListener("beforeunload", onLeave);
    return () => {
      window.removeEventListener("popstate", onHistory);
      window.removeEventListener("beforeunload", onLeave);
    };
  }, []);
  if (!error) return null;
  return <section role="alert" aria-label="Chat link unavailable" className="appToast appToast--error"
    style={{ pointerEvents: "auto", borderRadius: 18, width: 420, boxSizing: "border-box" }}>
    <div>{error}</div>
    <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>
      <button type="button" className="schedBtn" disabled={retrying} onClick={async () => {
        setRetrying(true);
        try { await useSession.getState().resolveChatLink(true); }
        finally { setRetrying(false); }
      }}>{retrying ? "Checking…" : "Retry"}</button>
      <button type="button" className="schedBtn" onClick={() => useSession.getState().dismissChatLinkError()}>
        {activeId ? "Stay in current chat" : "Choose another chat"}
      </button>
    </div>
  </section>;
}
